// Campus photo for /colleges/university-of-california-riverside: Public domain, by Arvind Ramanandan (Arvindleela), from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUCR_botanical_gardens.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-riverside/; credited under the photo.
const photo = {
    "slug": "university-of-california-riverside",
    "alt": "The UC Riverside campus below snow-capped mountains, seen from the botanic gardens in Riverside, California",
    "src": "/colleges/university-of-california-riverside/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-riverside/campus-800.webp",
    "srcMid": "/colleges/university-of-california-riverside/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-riverside/og.jpg",
    "title": "UCR botanical gardens",
    "author": "Arvind Ramanandan (Arvindleela)",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUCR_botanical_gardens.jpg",
    "read": "2026-09-30"
};

export default photo;
